import React, {Component} from 'react'
import {Helmet} from 'react-helmet'
import ReactGA from 'react-ga'
import {Jumbotron, Grid, Row, FormControl, Button} from 'react-bootstrap'
import MusicAlgoNav from '../MusicAlgoNav'
import MusicAlgoFooter from '../MusicAlgoFooter'
import './Feedback.css'

ReactGA.initialize('UA-75058203-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class Feedback extends Component {
  render() {
    return (
      <div>
      <Helmet>
          <title>Feedback | MusicAlgo</title>
          <meta name="description" content="Send us feedback about how we can make MusicAlgo even better." />
      </Helmet>
      <div className="cont">
      
      <Jumbotron style={{marginBottom:"30px"}}>
          <h1 className="titleHeader">Feedback</h1>
      </Jumbotron>
      <Grid>
      <form action="https://formspree.io/eric.festa2@gmail.com" method="post">
          <Row><FormControl type="text" name="name" placeholder="Name" required /></Row>
          <Row><FormControl type="email" name="email" placeholder="Email" required /></Row>
          <Row><FormControl componentClass="textarea" name="feedback" placeholder="Feedback" required /></Row>
          <FormControl type="hidden" name="_next" value="https://musicalgo.com/feedback" />
          <FormControl type="hidden" name="_subject" value="MusicAlgo Feedback" />
          <Button type="submit">Send</Button>
      </form>
      </Grid>
      </div>
      
      </div>
    )
  }
}
export default Feedback


// WEBPACK FOOTER //
// ./src/Feedback/Feedback.js